
export enum ContactEventType {
    CONTACT_CREATED = "contact.contactCreated",
    CONTACT_UPDATED = "contact.contactUpdated",
    CONTACT_DELETED = "contact.contactDeleted",
    CONTACT_CPMS_UPDATED = "contact.contactCpmsUpdated"
}
